const isBonusTotalRewardSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.BonusTotalRewardSection => {
  return s.sectionType === 'Bonus Total Reward';
};

export default isBonusTotalRewardSection;
